import { render, staticRenderFns } from "./SupportTicketMessageBubble.vue?vue&type=template&id=7297fe40&scoped=true&"
import script from "./SupportTicketMessageBubble.vue?vue&type=script&lang=ts&"
export * from "./SupportTicketMessageBubble.vue?vue&type=script&lang=ts&"
import style0 from "./SupportTicketMessageBubble.vue?vue&type=style&index=0&id=7297fe40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7297fe40",
  null
  
)

export default component.exports